<div [ngClass]="{'subBlockContainer': !setFullWindow , 'subBlockContainer_full':setFullWindow}">
  <div class="subBlockContent" id="selectazureri">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div>
      <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
      <div class="row filter-wrapper">
        <div class="listpart col-md-12">
          <!-- <mat-form-field class="usagesub">
            <mat-select placeholder="Please select usage subscription" (change)="selectUsageSubscription($event)">
              <mat-option *ngFor="let item of azureRiUsageSubscriptionList?.selectItemList" [value]="item?.value">
                {{item?.text}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <ng-select class="customDropdwon" [items]="azureRiUsageSubscriptionList?.selectItemList" bindValue="value" bindLabel="text" placeholder="Please select usage subscription" [(ngModel)]="selectedSubscriptionItem" (change)="selectUsageSubscription()">
          </ng-select>
        </div>
        <!-- <div class="listpart col-md-6">
          <ng-select class="customDropdwon" [items]="mpnList" bindValue="mpn" bindLabel="mpn" placeholder="Select / Enter New MPN ID" [(ngModel)]="azureRiMpnIdSelect">
          </ng-select>
        </div> -->
        <div class="listpart col-md-12">
          <!-- <mat-form-field>
            <input class="azurerimpn" type="text" name="matlocation" placeholder="Select Location" 
              [(ngModel)]="selectedLocation" matInput #trigger="matAutocompleteTrigger" [matAutocomplete]="autoLocation" (ngModelChange)="selectLocation()">
            <i class="material-icons align-arrow-right" (click)="showAutoCompletePanel(trigger);$event.stopPropagation()">arrow_drop_down</i>
            <mat-autocomplete #autoLocation="matAutocomplete">
              <mat-option *ngFor="let location of locationList" [value]="location">
                {{location}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field> -->
          <ng-select class="customDropdwon" [items]="locationList" bindValue="locationName" bindLabel="locationName" placeholder="Select Location" [(ngModel)]="selectedLocation" (change)="selectLocation()">
          </ng-select>
        </div>
        <div class="listpart col-md-12">
          <!-- <div class="checkbox-center"  *ngIf="azureRiList?.length">
            <mat-slide-toggle
              [checked]="isMonthlyPayment"
              (change)="toggleActive($event)">
              Pay monthly
            </mat-slide-toggle>
          </div> -->
          <ng-select class="customDropdwon" [items]="paymentFreqList" bindValue="value" bindLabel="value" placeholder="Payment frequency" [clearable]="false" [(ngModel)]="selectedPaymentFreq" (change)="selectPaymentFrequency()"></ng-select>
        </div>
        <div class="listpart div-seach" *ngIf="azureRiList?.length">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchAzureRi"
                (ngModelChange)="filterAzureRiItems()">
          </div>
        </div>
        <div class="col-md-12 align-center" *ngIf="!azureRiList?.length">
          <label class="noData-label">
            <!-- We couldn’t find any Azure Ri Catalog -->
          </label>
        </div>
      </div>
      <div class="shared-outer-wrapper" *ngIf="azureRiList?.length">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="align-left" style="width: 20%">STOCK CODE</th>
              <th scope="col" class="align-left" style="width: 45%">TITLE</th>
              <th scope="col" class="align-right" style="width: 10%">PRICE</th>
              <th scope="col" class="align-center" style="width: 15%">QUANTITY</th>
              <th scope="col" class="align-center" style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let software of azureRiListFilter">
              <td class="align-left" style="position: relative;vertical-align: middle; text-align: left">
                {{software?.productId+":"+software?.skuId}}
              </td>
              <td style="position: relative;vertical-align: middle;">
                <span class="description-popup">{{software?.title}}</span>
              </td>
              <td class="align-right" style="position: relative;vertical-align: middle;">
                 <span *ngIf="!isMonthlyPayment">{{software?.itemPrice | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                 <span *ngIf="isMonthlyPayment">{{software?.monthlyPrice | currency:'AUD':'symbol-narrow':'.2-2'}}/mth</span>
              </td>
              <td class="align-center" style="position: relative;vertical-align: middle;">
                <input class="align-center align-top input-wrapper input-wrapper-small" [(ngModel)]="software.quantity" type="text">
                <mat-icon matSuffix *ngIf="software?.minMaxQtyText" class="editmpnidicon align-top" placement="bottom" ngbTooltip="{{software?.minMaxQtyText}}">info</mat-icon>
              </td>
              <td class="align-center" style="vertical-align: middle;">
                <button mat-button id="{{software?.productId+'_'+software?.skuId}}" class="button button-red button-mid confirmbutton" (click)="AddAzureRiItem(software)" [disabled]="!priceList?.length">Add</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="button-center">
      <button *ngIf="azureRiList?.length && loadContent" class="button button-red button-large button-center-left" (click)="backToCatalogue()">Back To Catalogue</button>
      <button *ngIf="azureRiList?.length && loadContent" class="button button-red button-large button-center-right" (click)="finishAddAzureRi()">Continue</button>
    </div> 
  </div>
</div>